import PropTypes from 'prop-types'
import React from 'react'

import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

export const SKELETON_LOADER_VARIANT_ONWHITE = 'onwhite'
export const SKELETON_LOADER_VARIANT_ONGRAY = 'ongray'
export const SKELETON_LOADER_VARIANT_ONDARK = 'ondark'
export const SKELETON_LOADER_TYPE_CIRCLE = 'circle'

const gradient = keyframes`
0% {
  background-position: 100% 0;
}
100% {
  background-position: 0 0;
}
`

const Loader = styled.div`
  background: linear-gradient(90deg, #E8E8E8 35%, #ECECEC 50%, #E8E8E8 65%);
  background: ${props =>
    props.variant === SKELETON_LOADER_VARIANT_ONWHITE
      ? 'linear-gradient(90deg, #f0f0f0 35%, #f6f6f6 50%, #f0f0f0 65%);'
      : false}; 
  background: ${props =>
    props.variant === SKELETON_LOADER_VARIANT_ONDARK
      ? 'linear-gradient(90deg, #303030 35%, #353535 50%, #303030 65%);'
      : false}; 
  background-size: 300%;
  animation: ${gradient} 2s linear infinite;
  margin-bottom: 8px;
  ${({ type }) =>
    type === SKELETON_LOADER_TYPE_CIRCLE
      ? 'height: 70px; width: 70px; border-radius: 50%;'
      : 'height: 15px; width: 80%; border-radius: 50px;'}
  ${({ width }) => width && 'width:' + width + ';'}
  ${({ height }) => height && 'height:' + height + ';'}
  ${({ margin }) => (margin !== undefined ? `margin: ${margin};` : '')}
`

export const SkeletonLoader = ({
  className,
  width,
  height,
  margin,
  type, // ["default", "circle"]
  variant, // ["ongray", "onwhite"]
  style,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <Loader
      className={className}
      width={width}
      height={height}
      margin={margin}
      type={type}
      variant={variant}
      style={style}
      data-mu-test={dataAttributeTest}
    />
  )
}

SkeletonLoader.defaultProps = {
  variant: SKELETON_LOADER_VARIANT_ONGRAY,
  margin: '0 0 8px 0'
}

SkeletonLoader.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  type: PropTypes.oneOf([SKELETON_LOADER_TYPE_CIRCLE, undefined]),
  height: PropTypes.string,
  margin: PropTypes.string,
  variant: PropTypes.oneOf([
    SKELETON_LOADER_VARIANT_ONWHITE,
    SKELETON_LOADER_VARIANT_ONGRAY,
    SKELETON_LOADER_VARIANT_ONDARK
  ]),
  style: PropTypes.object,
  'data-mu-test': PropTypes.string
}
